import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { Tag } from '@/domain/tags/entities/tag.entity.ts';
import { translate } from '@/ui/i18n';

export const getTags = createAppAsyncThunk(
  'project/getTags',
  async (
    _,
    { extra: { tagsGateway, snackbarGateway } },
  ): Promise<Array<Tag>> => {
    try {
      return await tagsGateway.getTags();
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetTags.Message.error'));
}
